module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mr-7211bfd49f97a5ae1253d2172336ade9.svg";